// departmentActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';
import { CreateDepartmentPayload, UpdateDepartmentPayload, DeleteDepartmentPayload, FetchDepartmentByIdPayload } from './departmentTypes';

// Create Department
export const createDepartment = createAsyncThunk(
    'departments/createDepartment',
    async (data: CreateDepartmentPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/department', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create department');
        }
    }
);

// Update Department
export const updateDepartment = createAsyncThunk(
    'departments/updateDepartment',
    async ({ departmentId, ...data }: UpdateDepartmentPayload & { departmentId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/department/${departmentId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update department');
        }
    }
);

// Delete Department
export const deleteDepartment = createAsyncThunk(
    'departments/deleteDepartment',
    async ({ departmentId }: DeleteDepartmentPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/department/${departmentId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete department');
        }
    }
);

// Fetch Department by ID
export const fetchDepartmentById = createAsyncThunk(
    'departments/fetchDepartmentById',
    async ({ departmentId }: FetchDepartmentByIdPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/department/${departmentId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch department');
        }
    }
);

// Fetch All Departments
export const fetchAllDepartments = createAsyncThunk(
    'departments/fetchAllDepartments',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/department');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch departments');
        }
    }
);
